module.exports = __webpack_public_path__ + "img/south.4713af6b.png";